import { getFullPath, routes } from "../../routes";
import { GlobalSearchResult } from "@/api/williams/search";

export function getLinkPath(result: GlobalSearchResult) {
  switch (result.resultType) {
    case "Contractor":
      return getFullPath(routes.contractor.open(result.id));
    case "Project":
      return getFullPath(routes.project.open(result.id));
    case "Scope of Work":
      return getFullPath(routes.scopeOfWork.open(result.id));
    case "Test Event":
      return getFullPath(routes.testEvent.open(result.id));
    case "Welder":
      return getFullPath(routes.welder.open(result.id));
    default:
      return window.location;
  }
}
